<script>
export default {
  name: "IconSlidersVertical"
};
</script>

<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 2C16.5523 2 17 2.44772 17 3V12C18.1046 12 19 12.8954 19 14C19 15.1046 18.1046 16 17 16V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V16C13.8954 16 13 15.1046 13 14C13 12.8954 13.8954 12 15 12V3C15 2.44772 15.4477 2 16 2ZM17 13.2H15C14.5582 13.2 14.2 13.5582 14.2 14C14.2 14.4078 14.5052 14.7444 14.8996 14.7938L15 14.8H17C17.4418 14.8 17.8 14.4418 17.8 14C17.8 13.5922 17.4948 13.2556 17.1003 13.2062L17 13.2Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10 2C10.5523 2 11 2.44772 11 3V5C12.1046 5 13 5.89543 13 7C13 8.10457 12.1046 9 11 9V17C11 17.5523 10.5523 18 10 18C9.44772 18 9 17.5523 9 17V9C7.89543 9 7 8.10457 7 7C7 5.89543 7.89543 5 9 5V3C9 2.44772 9.44772 2 10 2ZM11 6.2H9C8.55817 6.2 8.2 6.55817 8.2 7C8.2 7.40784 8.50519 7.7444 8.89965 7.79377L9 7.8H11C11.4418 7.8 11.8 7.44183 11.8 7C11.8 6.59216 11.4948 6.2556 11.1004 6.20623L11 6.2Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4 2C4.55228 2 5 2.44772 5 3V10C6.10457 10 7 10.8954 7 12C7 13.1046 6.10457 14 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V14C1.89543 14 1 13.1046 1 12C1 10.8954 1.89543 10 3 10V3C3 2.44772 3.44772 2 4 2ZM5 11.2H3C2.55817 11.2 2.2 11.5582 2.2 12C2.2 12.4078 2.50519 12.7444 2.89965 12.7938L3 12.8H5C5.44183 12.8 5.8 12.4418 5.8 12C5.8 11.5922 5.49481 11.2556 5.10035 11.2062L5 11.2Z"
      fill="currentColor"
    />
  </svg>
</template>
